import api from './httpClient';

export const SettingsApi = {
  getPublicAdminSettings: async () => {
    const response = await api.get('/settings/admin-access');
    return response.data.data;
  },
  getSecureAdminSettings: async () => {
    const response = await api.get('/settings/admin-access/secure');
    return response.data.data;
  },
  updateAdminSettings: async (payload) => {
    const response = await api.put('/settings/admin-access', payload);
    return response.data.data;
  }
};
